"use client";

import Image from "next/image";

interface CardProps {
  image: string;
  title: string;
  description: string;
}

export const Card = ({ image, title, description }: CardProps) => (
  <div className="group relative aspect-[4/3] overflow-hidden rounded-xl bg-white shadow-md transition-shadow duration-500 hover:shadow-xl">
    <Image
      src={image}
      alt={title}
      fill
      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      className="object-cover transition-transform duration-700"
      quality={85}
    />

    {/* Overlay */}
    <div
      className={`
        absolute inset-0 
        bg-gradient-to-t from-black/70 to-transparent
        opacity-100
        [@media(hover:hover)]:opacity-0 
        [@media(hover:hover)]:group-hover:opacity-100
        transition-opacity duration-500 pointer-events-none
      `}
    />

    <div
      className={`
        absolute inset-0 flex flex-col justify-end
        p-3 sm:p-4 md:p-6
        text-white
        transition-all duration-500
        opacity-100
        [@media(hover:hover)]:opacity-0 
        [@media(hover:hover)]:group-hover:opacity-100
        translate-y-0
        [@media(hover:hover)]:translate-y-4 
        [@media(hover:hover)]:group-hover:translate-y-0
      `}
    >
      <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-1 sm:mb-2 drop-shadow-md">
        {title}
      </h3>
      <p className="text-xs sm:text-sm md:text-base leading-snug sm:leading-normal line-clamp-2 sm:line-clamp-3 drop-shadow-md">
        {description}
      </p>
    </div>
  </div>
);
